"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryListener = void 0;
var PushStateEvent = 'pushState';
var ReplaceStateEvent = 'replaceState';
var EVENT_PREFIX = 'apms_';
function overwriteHistoryFunction(eventType) {
    var originalFunction = window.history[eventType];
    var event = new Event("".concat(EVENT_PREFIX).concat(eventType));
    window.history[eventType] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var res = originalFunction.apply(window.history, args);
        // 先执行方法，更新location后再触发callback
        window.dispatchEvent(event);
        return res;
    };
}
var historyEventList = [
    'popstate',
    'hashchange',
    'beforeunload',
];
var historyReplacementEvent = [
    "".concat(EVENT_PREFIX, "replaceState"),
    "".concat(EVENT_PREFIX, "pushState"),
];
var HistoryListener = /** @class */ (function () {
    function HistoryListener() {
    }
    HistoryListener.dispatchEvent = function (eventType) {
        try {
            var event_1 = historyReplacementEvent.includes(eventType)
                ? eventType.replace(EVENT_PREFIX, '')
                : eventType;
            for (var _i = 0, _a = Object.values(HistoryListener.listenerMap); _i < _a.length; _i++) {
                var handler = _a[_i];
                handler(event_1);
            }
        }
        catch (error) {
            //
        }
    };
    HistoryListener.prototype.init = function () {
        if (HistoryListener.filled) {
            return;
        }
        try {
            overwriteHistoryFunction(PushStateEvent);
            overwriteHistoryFunction(ReplaceStateEvent);
            var _loop_1 = function (eventType) {
                window.addEventListener(eventType, function () {
                    /** asynchorously functions but would not be triggered multiple times generally */
                    HistoryListener.dispatchEvent(eventType);
                });
            };
            for (var _i = 0, historyEventList_1 = historyEventList; _i < historyEventList_1.length; _i++) {
                var eventType = historyEventList_1[_i];
                _loop_1(eventType);
            }
            var _loop_2 = function (eventType) {
                window.addEventListener(eventType, function () {
                    // synchorously functions and could be triggered multiple times
                    if (HistoryListener.lastHref === window.location.href) {
                        return;
                    }
                    HistoryListener.lastHref = window.location.href;
                    HistoryListener.dispatchEvent(eventType);
                });
            };
            for (var _a = 0, historyReplacementEvent_1 = historyReplacementEvent; _a < historyReplacementEvent_1.length; _a++) {
                var eventType = historyReplacementEvent_1[_a];
                _loop_2(eventType);
            }
            HistoryListener.filled = true;
        }
        catch (error) {
            //
        }
    };
    HistoryListener.prototype.add = function (de_app_id, handler) {
        HistoryListener.listenerMap[de_app_id] = handler;
        this.init();
    };
    HistoryListener.prototype.remove = function (de_app_id) {
        if (HistoryListener.listenerMap[de_app_id]) {
            delete HistoryListener.listenerMap[de_app_id];
        }
    };
    HistoryListener.listenerMap = {};
    HistoryListener.filled = false;
    HistoryListener.lastHref = window.location.href;
    return HistoryListener;
}());
exports.HistoryListener = HistoryListener;
